import type { Execution } from '../schemas';
import { mockSchedules } from './mockSchedules';
import { mockWorkflows } from './mockWorkflows';

// Generate mock executions for testing
export const mockExecutions: Execution[] = (() => {
  const executions: Execution[] = [];
  const statuses: Array<'pending' | 'running' | 'completed' | 'failed'> = [
    'completed',
    'failed',
    'running',
    'pending',
  ];
  const userIds = ['1', '2']; // Admin and regular user

  // Generate executions for the past 30 days
  for (let i = 0; i < 50; i++) {
    const scheduleIndex = Math.floor(Math.random() * mockSchedules.length);
    const schedule = mockSchedules[scheduleIndex];
    const workflow = mockWorkflows.find(w => w.id === schedule.workflowId);

    if (!workflow) continue;

    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const startedDate = new Date();
    startedDate.setDate(startedDate.getDate() - Math.floor(Math.random() * 30));
    startedDate.setHours(Math.floor(Math.random() * 24));
    startedDate.setMinutes(Math.floor(Math.random() * 60));

    let completedAt: string | undefined;
    let errorMessage: string | undefined;
    let resultFileUrl: string | undefined;
    let recordsProcessed: number | undefined;

    if (status === 'completed') {
      const completedDate = new Date(startedDate.getTime() + Math.random() * 3600000); // Up to 1 hour later
      completedAt = completedDate.toISOString();
      recordsProcessed = Math.floor(Math.random() * 10000) + 100;
      resultFileUrl = `/downloads/execution_${i + 1}_${workflow.exportFormat}`;
    } else if (status === 'failed') {
      const failedDate = new Date(startedDate.getTime() + Math.random() * 1800000); // Up to 30 minutes later
      completedAt = failedDate.toISOString();

      const errorMessages = [
        'Database connection timeout after 30 seconds',
        'Invalid SQL query: column "invalid_field" does not exist',
        'Memory limit exceeded while processing large dataset',
        'Network error: Unable to connect to data source',
        'Authentication failed: Invalid credentials for data source',
        'Rate limit exceeded: Too many requests to external API',
        'Data validation error: Required field "customer_id" is missing',
        'File system error: Unable to write to output directory',
        'Timeout error: Query execution exceeded maximum allowed time',
        'Permission denied: Insufficient privileges to access table',
        'Data format error: Invalid date format in source data',
        'Resource unavailable: External service temporarily down',
      ];
      errorMessage = errorMessages[Math.floor(Math.random() * errorMessages.length)];
    } else if (status === 'running') {
      recordsProcessed = Math.floor(Math.random() * 5000);
    }

    executions.push({
      id: (i + 1).toString(),
      scheduleId: schedule.id,
      workflowId: workflow.id,
      status,
      startedAt: startedDate.toISOString(),
      completedAt,
      errorMessage,
      resultFileUrl,
      recordsProcessed,
      userId: schedule.userId,
    });
  }

  // Sort by most recent first
  return executions.sort(
    (a, b) => new Date(b.startedAt).getTime() - new Date(a.startedAt).getTime(),
  );
})();
